import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone, MessageCircle } from "lucide-react";
import { NAV_LINKS, COMPANY, whatsappLink } from "@/data/site";

const DesktopNav = () => (
  <nav className="hidden lg:flex items-center gap-7" data-testid="desktop-nav">
    {NAV_LINKS.map((l) => (
      <NavLink
        key={l.to}
        to={l.to}
        end={l.to === "/"}
        data-testid={`nav-${l.label.toLowerCase().replace(/\s|&|\//g,'-')}`}
        className={({isActive}) =>
          `nav-link text-[13px] tracking-[.08em] uppercase font-semibold transition-colors hover:text-[#E8721C] ${
            isActive ? `is-active ${l.to === "/export-import" ? "text-[#C8973C]" : "text-[#E8721C]"}` : "text-white/85"
          }`
        }
      >{l.label}</NavLink>
    ))}
  </nav>
);

const MobileOverlay = ({ open, onClose }) => (
  <div
    data-testid="mobile-menu-overlay"
    className={`fixed inset-0 z-[80] bg-[#0A1628] text-white transform transition-transform duration-300 ${open ? "translate-x-0" : "translate-x-full"} blueprint-grid`}
  >
    <div className="flex items-center justify-between h-[72px] px-5 border-b border-white/10">
      <span className="font-display text-[22px]">CASSIE GEE</span>
      <button onClick={onClose} aria-label="Close menu" data-testid="mobile-menu-close"><X size={28}/></button>
    </div>
    <div className="px-5 py-8 flex flex-col gap-5">
      {NAV_LINKS.map((l) => (
        <NavLink
          key={l.to}
          to={l.to}
          end={l.to === "/"}
          data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s|&|\//g,'-')}`}
          className={({isActive}) =>
            `font-display text-[28px] tracking-wide ${isActive ? "text-[#E8721C]" : "text-white"}`
          }
        >{l.label}</NavLink>
      ))}
      <Link to="/contact" className="btn-orange mt-3 self-start" data-testid="mobile-quote-btn">Request a Quote</Link>
    </div>
    <div className="absolute bottom-0 left-0 right-0 px-5 py-6 border-t border-white/10 bg-[#1E2D40]">
      <div className="text-[11px] tracking-[.18em] text-[#8A96A3] mb-3">DIRECT CONTACT</div>
      {COMPANY.phones.map((p) => (
        <a key={p} href={`tel:${p.replace(/\s/g,'')}`} className="flex items-center gap-3 py-1 text-white">
          <Phone size={16} className="text-[#E8721C]"/> <span>{p}</span>
        </a>
      ))}
      <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 py-1 text-[#25D366] font-semibold mt-2">
        <MessageCircle size={16}/> WhatsApp Us
      </a>
    </div>
  </div>
);

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  useEffect(() => { setOpen(false); }, [loc.pathname, setOpen]);

  return (
    <>
      <div className="h-[4px] bg-[#E8721C]" />
      <header className="sticky top-0 z-50 bg-[#0A1628] text-white border-b border-white/5" data-testid="navbar">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 flex items-center justify-between h-[72px]">
          <Link to="/" className="flex items-center gap-3" data-testid="logo-home-link">
            <div className="font-display text-[22px] leading-none tracking-wide">CASSIE&nbsp;GEE</div>
            <div className="hidden md:block text-[10px] tracking-[.18em] text-[#8A96A3] border-l border-white/10 pl-3">
              INVESTMENTS CC<br/>
              <span className="text-[#E8721C] font-bold">EST. 2003 · 23 YEARS</span>
            </div>
            <span className="ml-2 bg-[#E8721C] text-white text-[10px] font-bold px-2 py-[3px] tracking-widest">23 YRS</span>
          </Link>
          <DesktopNav />
          <div className="hidden lg:block">
            <Link to="/contact" className="btn-orange" data-testid="get-quote-btn">Get a Quote</Link>
          </div>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden p-2 text-white"
            onClick={() => setOpen(true)}
            aria-label="Open menu"
          ><Menu size={28} /></button>
        </div>
      </header>
      <MobileOverlay open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default Navbar;
